import * as Sentry from "@sentry/gatsby"

Sentry.init({
  dsn: process.env.GATSBY_SENTRY_DSN,
  environment: process.env.GATSBY_SENTRY_ENVIRONMENT,
  enabled: process.env.NODE_ENV === "production",
  autoSessionTracking: true,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  release: process.env.GATSBY_SENTRY_RELEASE,
  sampleRate: 1.0,
})